import { CtaButtonType, CtaForm } from '@pairy/sheard/types';

import {
  HyperLinkType,
  BulkFileResponseType,
  GetBulkFilePreviewResponse,
} from '../../types/file';
import { ImageSourcesDto } from '../../types/imageSources';
import {
  MessageBoxItemType,
  PdfViewerRedirect,
} from '../PdfViewer/index.types';

export interface V2PageType {
  page: number;
  /** 레거시(단일 이미지) URL — imageSources가 없을 때 fallback으로 사용 */
  src: string;
  originalWidth: number;
  originalHeight: number;
  hyperlink: HyperLinkType[];
  imageSources?: ImageSourcesDto;
}

export interface V2DocumentType {
  name: string;
  totalPages: number;
  pages: V2PageType[];
  isDownloadEnabled: boolean;
  isShareable: boolean;
  plan: 'Pro' | 'Free' | 'Basic' | 'Pro Plus';
}

export interface V2CtaConfigType {
  ctaForm?: CtaForm;
  ctaButtonList?: CtaButtonType[];
  isEmailVerificationEnabled: boolean;
  isFormSubmitted?: boolean;
}

export interface V2ResizedImageSize {
  widthRatio: number;
  heightRatio: number;
  xMargin: number;
  yMargin: number;
  width: number;
  height: number;
}

export const adaptOneToOneDocument = (
  data: PdfViewerRedirect,
): V2DocumentType => ({
  name: data.name,
  totalPages: Number(data.pages),
  pages: data.thumnail.map((item) => ({
    page: item.page,
    src: item.thumnail,
    originalWidth: item.originalWidth,
    originalHeight: item.originalHeight,
    hyperlink: item.hyperlink,
    imageSources: item.imageSources,
  })),
  isDownloadEnabled: data.isDownloadEnabled,
  isShareable: false,
  plan: data.userSubscriptionPlan,
});

/** 관리자 미리보기용 1:1 문서 어댑터(다운로드/공유 비활성) */
export const adaptOneToOnePreviewDocument = (
  data: Omit<PdfViewerRedirect, 'isDownloadEnabled'>,
): V2DocumentType => ({
  name: data.name,
  totalPages: Number(data.pages),
  pages: data.thumnail.map((item) => ({
    page: item.page,
    src: item.thumnail,
    originalWidth: item.originalWidth,
    originalHeight: item.originalHeight,
    hyperlink: item.hyperlink,
    imageSources: item.imageSources,
  })),
  isDownloadEnabled: false,
  isShareable: false,
  plan: data.userSubscriptionPlan,
});

/** 관리자 미리보기용 벌크 문서 어댑터(다운로드/공유 비활성) */
export const adaptBulkPreviewDocument = (
  data: GetBulkFilePreviewResponse,
): V2DocumentType => ({
  name: data.file.name,
  totalPages: Number(data.file.pages),
  pages: data.file.thumbnails.map((item) => ({
    page: item.page,
    src: item.thumbnail,
    originalWidth: item.originalWidth,
    originalHeight: item.originalHeight,
    hyperlink: item.hyperlink,
    imageSources: item.imageSources,
  })),
  isDownloadEnabled: false,
  isShareable: false,
  plan: data.user.plan,
});

export const adaptBulkDocument = (
  data: BulkFileResponseType,
): V2DocumentType => ({
  name: data.file.name,
  totalPages: Number(data.file.pages),
  pages: data.file.thumbnails.map((item) => ({
    page: item.page,
    src: item.thumbnail,
    originalWidth: item.originalWidth,
    originalHeight: item.originalHeight,
    hyperlink: item.hyperlink,
    imageSources: item.imageSources,
  })),
  isDownloadEnabled: data.file.isDownloadEnabled,
  isShareable: true,
  plan: data.user.plan,
});

export type { MessageBoxItemType };
